<template>
    <div v-if="!show" class="fullCard">
      <ul>
        <span v-if="!chats[0]">Try publish an article!</span>
        <li v-for="chat of chats" :key="chat.id">
          <router-link :to="{ name: 'chat', params: { id: chat.id } }">{{ chat.title }}</router-link>
        </li>
      </ul>
    </div>
</template>

<script>
import { db } from '../firebase';


export default {
    
    data() {
        return { 
            chats: [],
        }
    },
    firestore() {
        return { 
            chats: db.collection('chats').where('owner', '==', this.uid) 
        }
    },
    props: ['uid', 'show']
}
</script>